<template>
  <header class="app-header">
    <template v-if="theme === 'kids'">
      <HeaderMainKids
        :is-open-menu="isShowMenu"
        :is-mobile-search="isMobileSearch"
        @open-partner-form="openPartnerForm"
        @search="setQuery"
        @toogle-menu="toogelMobileMenu"
        @toogle-mobile-search="toogleMobileSearch"
        @close-mobile-menu="isShowMenu = false"
      />
    </template>
    <template v-else>
      <HeaderMain
        :is-open-menu="isShowMenu"
        :is-mobile-search="isMobileSearch"
        @search="setQuery"
        @toogle-menu="toogelMobileMenu"
        @toogle-mobile-search="toogleMobileSearch"
        @close-mobile-menu="isShowMenu = false"
      />
    </template>

    <HeaderMobileMenu
      v-if="theme !== 'kids' && isShowMenu"
      @close-menu="isShowMenu = false"
      @open-partner-form="openPartnerForm"
    />
    <ProductSearchList
      v-if="isMobileSearch && theme === 'default'"
      :products="productSearchStore.getProducts"
      @scrolled-to-bottom="productSearchStore.loadProducts"
    />

    <HeaderNav v-show="!isMobileSearch && theme !== 'kids'" class="hidden xl:flex mb-4" />
  </header>
  <main class="main" :class="{ hidden: isShowMenu || isMobileSearch }">
    <slot></slot>
  </main>
  <footer
    class="bg-[#F0F2F4]"
    :class="{
      hidden: isShowMenu || isMobileSearch,
      'hidden-on-mobile': $route.name === '/cart',
    }"
  >
    <template v-if="theme === 'kids'">
      <FooterMainKids />
    </template>

    <template v-else>
      <FooterMain />
    </template>
  </footer>
  <PartnersForm
    :type="isOpenPartnerForm.type"
    :is-open="isOpenPartnerForm.open"
    @close-modal="isOpenPartnerForm.open = false"
  />
</template>

<script setup>
import { ref, onMounted, watch } from "vue"
import { useProductSearchStore } from "@/stores/productSearchStore"
import { useCategoriesStore } from "@/stores/categoriesStore"

import { useRoute } from "vue-router"

import { theme } from "@/services/getSiteTheme"

import HeaderMain from "@/components/header/HeaderMain.vue"
import HeaderMobileMenu from "@/components/header/mobile-menu/HeaderMobileMenu.vue"
import ProductSearchList from "../components/header/product-search-list/ProductSearchList.vue"
import HeaderNav from "../components/header/header-nav/HeaderNav.vue"
import FooterMain from "../components/footer/FooterMain.vue"
import FooterMainKids from "@/components/footer/FooterMainKids.vue"
import HeaderMainKids from "@/components/header/HeaderMainKids.vue"
import PartnersForm from "@/components/partners-form/PartnersForm.vue"

const route = useRoute()

const productSearchStore = useProductSearchStore()
const categoriesStore = useCategoriesStore()

const isShowMenu = ref(false)
const isMobileSearch = ref(false)
const isOpenPartnerForm = ref({
  type: "partners",
  open: false,
})

const openPartnerForm = (type) => {
  isOpenPartnerForm.value = {
    type,
    open: true,
  }
}

const toogelMobileMenu = () => {
  isMobileSearch.value = false
  isShowMenu.value = !isShowMenu.value
}

const toogleMobileSearch = () => {
  isShowMenu.value = false
  isMobileSearch.value = !isMobileSearch.value
}

const setQuery = (query) => {
  productSearchStore.setProductQuery(query)
}

onMounted(() => {
  categoriesStore.loadCategories()
})

watch(route, () => {
  isShowMenu.value = false
  isMobileSearch.value = false
})
</script>

<style lang="scss" scoped>
.app-header {
  background: var(--color-cream);
}
</style>
